import { Component } from '@angular/core';
import { uniqueId } from './lib/helpers';
import { FilterService } from './filter.service';

@Component({
  selector: 'app-filter',
  templateUrl: '../templates/filter.component.html',
  styleUrls: ['../styles/components/filter.component.less']
})
export class FilterComponent {
  sliders: any[];
  triggerTimeout: number;
  activitiesInput = '';
  targetAudiencesInput = '';
  id = uniqueId('filter_');

  constructor(private filterService: FilterService) {}

  triggerFilter(value: string, type: string) {
    if (typeof window !== 'undefined') {
      window.clearTimeout(this.triggerTimeout);
      this.triggerTimeout = window.setTimeout(() => this.filterList(value, type), 500);
    }
  }

  filterList(value: string, type: string) {
    this.filterService.filterList(value, type);
  }
}
